import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';
import useGetParamsForRequest from '../../../../shared/hooks/useGetParamsForRequest';
import useAddAttachmentsNote from './useAddAttachmentsNote';

const addComment = async ({ comment, id }) => {
  return await request.post(
    `/Access/transport/${id}/note`,
    {
      comment,
      availableForClient: true,
    },
    'При добавлении комментария произошла ошибка',
    'Error'
  );
};

const useAddComment = () => {
  const queryClient = useQueryClient();

  const paramsRequestPermits = useGetParamsForRequest();

  const { mutateAsync: addAttach, isLoading: isLoadingAttach } =
    useAddAttachmentsNote();

  const mutation = useMutation(addComment, {
    onSuccess: async (data, { id, attachments }) => {
      if (data === 'Error') return;

      if (!!attachments?.length) {
        await addAttach({ id: data, files: attachments });
      }

      queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading || isLoadingAttach,
  };
};

export default useAddComment;
